import { render, staticRenderFns } from "./MassViz.vue?vue&type=template&id=f395ba82&scoped=true"
import script from "./MassViz.vue?vue&type=script&lang=js"
export * from "./MassViz.vue?vue&type=script&lang=js"
import style0 from "./MassViz.vue?vue&type=style&index=0&id=f395ba82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f395ba82",
  null
  
)

export default component.exports